import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Route } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']

})
export class HomeComponent implements OnInit {

  constructor() {
    
   }

  ngOnInit(): void {
  }

 
}
